import {
  RateItemWrapper,
  RateItemValue,
  RateItemTitle,
} from './rateitem.style';
import React from 'react';
import communicationIllu from '@core/ui/static/images/communication-illustration.svg';
import punctualityIllu from '@core/ui/static/images/punctuality-illustration.svg';
import qualityIllu from '@core/ui/static/images/quality-illustration.svg';
import { useTranslation } from 'next-i18next';

const RateItem = ({ value, type }) => {
  const { t } = useTranslation();

  const printIcon = () => {
    let src = '';
    switch (type) {
      case 'communication':
        src = communicationIllu;
        break;
      case 'punctuality':
        src = punctualityIllu;
        break;
      case 'quality':
        src = qualityIllu;
        break;
      default:
        break;
    }
    return (
      <img
        src={src}
        alt="Date de publication"
        style={{
          height: '44px',
        }}
      />
    );
  };

  const printTitle = () => {
    let title = '';
    switch (type) {
      case 'communication':
        title = t('review.communication');
        break;
      case 'punctuality':
        title = t('review.punctuality');
        break;
      case 'quality':
        title = t('review.quality');
        break;
      default:
        break;
    }
    return <RateItemTitle>{title}</RateItemTitle>;
  };

  return (
    <RateItemWrapper>
      {printIcon()}

      <RateItemValue>{value}</RateItemValue>

      {printTitle()}
    </RateItemWrapper>
  );
};

export default RateItem;
